import { hasNoLabelPredictionUnits } from '@modules/feedback/components/FeedbackCard/utils/hasNoLabelPredictionUnits';
import filter from 'lodash/filter';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { FeedbackMetaData } from 'v2/store/useViewFeedbackStore';

export const getSelectedLabels = (
  labels: FeedbackLabel[] | undefined,
  selectedFeedbackMetadata: FeedbackMetaData[] | undefined,
  disableFilteringBasedOnPredictionUnits?: boolean,
) => {
  if (!labels?.length || !selectedFeedbackMetadata?.length) {
    return [];
  }

  return filter(labels, (label) => {
    if (!selectedFeedbackMetadata?.length) {
      return [];
    }

    if (
      hasNoLabelPredictionUnits(label) &&
      !disableFilteringBasedOnPredictionUnits
    ) {
      return false;
    }

    return selectedFeedbackMetadata.some((metadata) => {
      return metadata.id === label.id;
    });
  }) as FeedbackLabel[];
};
